import { createContext, useContext } from 'react';

import {
	PaymentReason,
	PaymentReasonType,
} from '~features/annals/enums/payment';
import ClientLogger from '~logger/client';
import { LoggerMessages, LoggerServices } from '~logger/constants';

import type { TBotPaywallContext } from './types';

export const BotPaywallContext = createContext<TBotPaywallContext>({
	isOpen: false,
	botId: undefined,
	reason: PaymentReason.Unknown,
	reasonType: PaymentReasonType.Unknown,
	openBotPaywall: () => undefined,
	closeBotPaywall: () => undefined,
});

export const useBotPaywallContext = () => {
	const context = useContext(BotPaywallContext);
	if (!context) {
		ClientLogger.error(
			LoggerServices.BotService,
			LoggerMessages.BotContextError,
			{}
		);
		throw Error('BotPaywallContext context no context Provider');
	}
	return context;
};
